import SgAccessibilityUtils from '../sg-accessibility-util';

function isPhoneMediaBreakpoint(breakpoint) {
    return breakpoint === 'phone';
}

function isTouchScreenDevice() {
    return ('ontouchstart' in document.documentElement) && window.matchMedia('(max-width: 1024px)').matches
        && !SgAccessibilityUtils.isAccessibilityNavigation();
}

function isMobileDevice(breakpoint) {
    return isPhoneMediaBreakpoint(breakpoint) && isTouchScreenDevice();
}

function isAndroid() {
    return /(android)/i.test(navigator.userAgent);
}

function isMac() {
    return navigator.userAgent.indexOf('Mac') !== -1;
}

function isIOS() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
}

export default {
    isMobileDevice,
    isAndroid,
    isIOS,
    isMac
};
